import { Pipe, PipeTransform } from '@angular/core';

import { pedidoStatus } from '../pedido-status';

@Pipe({
    name: 'pedidoStatus'
})
export class PedidoStatusPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = pedidoStatus.findIndex(status => status.id === value);
        if (index > -1) {
            return pedidoStatus[index].nome;
        }
        return '';
    }
}
